import React from 'react'
import {Icon} from '@chakra-ui/react'

const DownloadIcon = (props) => {
    return (
        <Icon viewBox="0 0 48 48" {...props}>
            <path
                d="M24.48 33.9638L30.429 28.1154C30.8071 27.7437 31.4149 27.7489 31.7866 28.127C32.1583 28.5051 32.1531 29.1129 31.775 29.4846L23.5304 37.5897L15.1719 29.4894C14.7912 29.1204 14.7816 28.5126 15.1506 28.1319C15.5196 27.7512 16.1274 27.7416 16.5081 28.1106L22.56 33.9756V0.96C22.56 0.429807 22.9898 0 23.52 0C24.0502 0 24.48 0.429807 24.48 0.96V33.9638Z"
                fill="currentColor"
            />
            <path
                d="M1.92 46.1124V28.7838C1.92 28.2626 1.49019 27.84 0.96 27.84C0.429807 27.84 0 28.2626 0 28.7838V48H48V28.7838C48 28.2626 47.5702 27.84 47.04 27.84C46.5098 27.84 46.08 28.2626 46.08 28.7838V46.1124H1.92Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default DownloadIcon
